import React, { useState } from 'react';
import { Helmet } from 'react-helmet-async';
import Layout from '../components/Layout';
import './TeamsPage.css';

const TeamsPage = () => {
    const [activeTab, setActiveTab] = useState('microbial');

    return (
        <Layout>
            <Helmet>
                <title>Our Team - Adept Knowledge Technologies</title>
                <meta name="description" content="Meet the expert team at Adept Knowledge Technologies — specialists in applied AI, autonomous sensing systems, microbiology, and dairy health innovation working to solve real-world livestock challenges." />
                <link rel="canonical" href="https://www.ak-tech.in/teams" />
                <meta property="og:title" content="Our Team - Adept Knowledge Technologies" />
                <meta property="og:description" content="Specialists in applied AI, autonomous sensing systems, microbiology, and dairy health innovation." />
                <meta property="og:url" content="https://www.ak-tech.in/teams" />
                <meta name="twitter:title" content="Our Team - Adept Knowledge Technologies" />
                <meta name="twitter:description" content="Specialists in applied AI, autonomous sensing systems, microbiology, and dairy health innovation." />
            </Helmet>
            <section className="teams-section">
                <div className="teams-container">
                    {/* Dark Green Banner for Core Team */}
                    <div className="core-team-banner">
                        <h1>Core Team</h1>
                    </div>

                    {/* Abinaya Section - No card, horizontal layout with animations */}
                    <div className="abinaya-section">
                        <div className="abinaya-image-container">
                            <div className="abinaya-image-wrapper">
                                <img
                                    src="/images/abimam.png"
                                    alt="Abinaya Sowriraghavan"
                                    className="abinaya-image"
                                />
                            </div>
                            <a
                                href="https://www.linkedin.com/in/abinayasowriraghavan/?originalSubdomain=uk"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="abinaya-linkedin-icon"
                            >
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" width="24" height="24">
                                    <path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z" />
                                </svg>
                            </a>
                        </div>
                        <div className="abinaya-info">
                            <h2 className="abinaya-name">Abinaya Sowriraghavan</h2>
                            <h3 className="abinaya-role">Founder</h3>
                            <p className="abinaya-description">
                                Abi is an applied AI specialist with a strong foundation in machine learning applied to precision diagnostics for dairy animal health. Her work centres on building research-grade systems that translate farm-scale data into actionable clinical signals — spanning early risk stratification, decision support, and treatment optimization. She specialises in robust inference under real-world constraints: noisy and sparse data, variable operating conditions, and the need for high sensitivity at low false-alarm rates, so diagnostic systems perform reliably in the environments that need them most.
                                <br /><br />
                                Prior to this, Abi spent several years in academia as a Teaching Fellow and Programme Director for the MSc Computer Science programme at Aston University, teaching across the MSc AI, AI with Business Strategy, and Applied AI programmes and shaping outcomes‑focused postgraduate curriculum design. She received awards for teaching excellence in higher education, is a Senior Fellow of the Higher Education Academy (UK), and holds an MBA from Cardiff University, combining deep technical grounding in AI with strategic leadership and execution.
                            </p>
                        </div>
                    </div>

                    {/* Karthik Section - No card, horizontal layout with animations */}
                    <div className="abinaya-section">
                        <div className="abinaya-image-container">
                            <div className="abinaya-image-wrapper">
                                <img
                                    src="/images/karthik.jpeg"
                                    alt="Karthik Thangaraj"
                                    className="abinaya-image"
                                />
                            </div>
                            <a
                                href="https://www.linkedin.com/in/kthangaraj/"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="abinaya-linkedin-icon"
                            >
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" width="24" height="24">
                                    <path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z" />
                                </svg>
                            </a>
                        </div>
                        <div className="abinaya-info">
                            <h2 className="abinaya-name">Karthik Thangaraj</h2>
                            <h3 className="abinaya-role">Chief Technology Officer</h3>
                            <p className="abinaya-description">
                                Dr. Karthik leads the company's deep‑tech engineering vision, focusing on the design and development of autonomous sensing systems, low‑power electronics, and intelligent hardware‑software platforms. With over 15 years of experience across aerospace, energy, rail, and critical infrastructure sectors, Karthik brings deep expertise in building technology from first principles through to real‑world deployment.
                                <br /><br />
                                He holds a PhD in Electrical Engineering from Cardiff University, with doctoral and post‑doctoral work centred on energy harvesting, ultra‑low‑power electronics, and autonomous wireless sensor systems developed in collaboration with industrial partners including Airbus. His work has delivered battery‑free and self‑powered sensing solutions for structural health monitoring, asset condition monitoring, and safety‑critical environments.
                                <br /><br />
                                As CTO, Karthik oversees system architecture, electronics design, embedded intelligence, and applied AI integration across products. He specialises in power‑aware circuit design, sensor fusion, edge intelligence, and ruggedised electronics for long‑term autonomous operation. He works closely with multidisciplinary teams to translate advanced research into scalable, manufacturable technologies, positioning the company at the forefront of sustainable sensing, intelligent instrumentation, and next‑generation connected systems.
                            </p>
                        </div>
                    </div>

                    {/* Tabs Section */}
                    <div className="team-tabs-container">
                        <div className="team-tabs">
                            <button
                                className={`team-tab ${activeTab === 'microbial' ? 'active' : ''}`}
                                onClick={() => setActiveTab('microbial')}
                            >
                                <i className="fas fa-microscope tab-icon"></i>
                                <span className="tab-text">Microbial Systems & Disease Dynamics</span>
                            </button>
                            <button
                                className={`team-tab ${activeTab === 'bioelectronic' ? 'active' : ''}`}
                                onClick={() => setActiveTab('bioelectronic')}
                            >
                                <i className="fas fa-microchip tab-icon"></i>
                                <span className="tab-text">Bioelectronic Systems & Device Engineering</span>
                            </button>
                            <button
                                className={`team-tab ${activeTab === 'ai' ? 'active' : ''}`}
                                onClick={() => setActiveTab('ai')}
                            >
                                <i className="fas fa-brain tab-icon"></i>
                                <span className="tab-text">Translational AI & Digital Therapeutics</span>
                            </button>
                            <button
                                className={`team-tab ${activeTab === 'mentor' ? 'active' : ''}`}
                                onClick={() => setActiveTab('mentor')}
                            >
                                <i className="fas fa-user-tie tab-icon"></i>
                                <span className="tab-text">Mentor</span>
                            </button>
                        </div>
                    </div>

                    {/* Tab Content */}
                    <div className="tab-content">
                        {/* Microbial Systems & Disease Dynamics Section */}
                        {activeTab === 'microbial' && (
                            <div className="tab-panel">
                                {/* First row - 2 cards */}
                                <div className="team-grid-two">
                                    {/* Research Associate I */}
                                    <div className="team-card hiring-card">
                                        <div className="team-card-inner">
                                            <div className="team-icon-wrapper">
                                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="user-icon">
                                                    <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z" />
                                                </svg>
                                            </div>
                                            <div className="team-info">
                                                <h2 className="team-name">Research Associate I</h2>
                                                <h3 className="team-role hiring-status">Hiring Ongoing</h3>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Shruthi Pai - Project Associate I */}
                                    <div className="team-card">
                                        <div className="team-card-inner">
                                            <div className="team-image-wrapper">
                                                <img
                                                    src="/images/shruthi1.png"
                                                    alt="Shruthi Pai"
                                                    className="team-image"
                                                />
                                            </div>
                                            <div className="team-info">
                                                <h2 className="team-name">Shruthi Pai</h2>
                                                <h3 className="team-role">Project Associate - I</h3>
                                                <p className="team-description">
                                                    Shruthi Pai is a microbiology researcher with a strong foundation in applied and molecular microbiology, including microbial genetics, genomics, and pathogen analysis. Her research interests centre on understanding microbial behaviour, antimicrobial resistance mechanisms, and disease‑associated microbial signatures using a combination of laboratory‑based microbiology and computational analysis.
                                                </p>
                                                <a
                                                    href="https://www.linkedin.com/in/shruthi-pai-428082252/?originalSubdomain=in"
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    className="linkedin-link"
                                                >
                                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" width="24" height="24">
                                                        <path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z" />
                                                    </svg>
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {/* Second row - 1 card centered */}
                                <div className="team-grid-single">
                                    {/* Project Associate */}
                                    <div className="team-card hiring-card">
                                        <div className="team-card-inner">
                                            <div className="team-icon-wrapper">
                                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="user-icon">
                                                    <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z" />
                                                </svg>
                                            </div>
                                            <div className="team-info">
                                                <h2 className="team-name">Project Associate</h2>
                                                <h3 className="team-role hiring-status">Hiring Ongoing</h3>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}

                        {/* Bioelectronic Systems & Device Engineering Section */}
                        {activeTab === 'bioelectronic' && (
                            <div className="tab-panel">
                                {/* First row - 2 cards */}
                                <div className="team-grid-two">
                                    {/* Research Associate I */}
                                    <div className="team-card">
                                        <div className="team-card-inner">
                                            <div className="team-image-wrapper">
                                                <img
                                                    src="/images/Venkatesh.png"
                                                    alt="Venkatesh"
                                                    className="team-image"
                                                />
                                            </div>
                                            <div className="team-info">
                                                <h2 className="team-name">Venkatesh Dayanidhi</h2>
                                                <h3 className="team-role">Project Lead - Electronics</h3>
                                                <p className="team-description">
                                                    Venkatesh Dayanidhi is an accomplished Electronics professional with around 20 years of expertise spanning both industry and academia. Currently serving as a Project Lead in Electronics, he brings strong expertise in RF and microwave engineering, electromagnetic fields, signal processing, and communication systems.
                                                    <br /><br />
                                                    His combined industry exposure and academic background enable him to lead complex electronics projects with a balance of theoretical insight and practical implementation. He is known for his technical depth, mentorship abilities, and commitment to delivering high-quality engineering solutions. He is passionate about innovation, continuous learning, and applying advanced electronics concepts to real-world challenges.
                                                </p>
                                                <a
                                                    href="https://www.linkedin.com/in/venkatesh-dayanidhi-98087112/"
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    className="linkedin-link"
                                                >
                                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" width="24" height="24">
                                                        <path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z" />
                                                    </svg>
                                                </a>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Senior Project Associate - Hiring Ongoing */}
                                    <div className="team-card hiring-card">
                                        <div className="team-card-inner">
                                            <div className="team-icon-wrapper">
                                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="user-icon">
                                                    <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z" />
                                                </svg>
                                            </div>
                                            <div className="team-info">
                                                <h2 className="team-name">Senior Project Associate</h2>
                                                <h3 className="team-role hiring-status">Hiring Ongoing</h3>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {/* Second row - 1 card centered */}
                                <div className="team-grid-single">
                                    {/* Project Associate */}
                                    <div className="team-card hiring-card">
                                        <div className="team-card-inner">
                                            <div className="team-icon-wrapper">
                                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="user-icon">
                                                    <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z" />
                                                </svg>
                                            </div>
                                            <div className="team-info">
                                                <h2 className="team-name">Project Associate</h2>
                                                <h3 className="team-role hiring-status">Hiring Ongoing</h3>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}

                        {/* Translational AI & Digital Therapeutics Section */}
                        {activeTab === 'ai' && (
                            <div className="tab-panel">
                                {/* First row - 2 cards */}
                                <div className="team-grid-two">
                                    {/* Research Associate I */}
                                    <div className="team-card hiring-card">
                                        <div className="team-card-inner">
                                            <div className="team-icon-wrapper">
                                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="user-icon">
                                                    <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z" />
                                                </svg>
                                            </div>
                                            <div className="team-info">
                                                <h2 className="team-name">Research Associate I</h2>
                                                <h3 className="team-role hiring-status">Hiring Ongoing</h3>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Project Associate */}
                                    <div className="team-card hiring-card">
                                        <div className="team-card-inner">
                                            <div className="team-icon-wrapper">
                                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="user-icon">
                                                    <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z" />
                                                </svg>
                                            </div>
                                            <div className="team-info">
                                                <h2 className="team-name">Project Associate</h2>
                                                <h3 className="team-role hiring-status">Hiring Ongoing</h3>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {/* Second row - 1 card centered */}
                                <div className="team-grid-single">
                                    {/* Project Associate */}
                                    <div className="team-card hiring-card">
                                        <div className="team-card-inner">
                                            <div className="team-icon-wrapper">
                                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="user-icon">
                                                    <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z" />
                                                </svg>
                                            </div>
                                            <div className="team-info">
                                                <h2 className="team-name">Project Associate</h2>
                                                <h3 className="team-role hiring-status">Hiring Ongoing</h3>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}

                        {/* Mentor Section */}
                        {activeTab === 'mentor' && (
                            <div className="tab-panel">
                                <div className="design-bench-grid">
                                    <div className="team-card">
                                        <div className="team-card-inner">
                                            <div className="team-image-wrapper">
                                                <img
                                                    src="/images/OPCImage.png"
                                                    alt="Dr. O.P. Chaudhary"
                                                    className="team-image"
                                                />
                                            </div>
                                            <div className="team-info">
                                                <h2 className="team-name">Dr. O.P. Chaudhary</h2>
                                                <h3 className="team-role">Mentor</h3>
                                                <p className="team-description">
                                                    Dr. O.P. Chaudhary is a highly respected former Indian Civil Servant with over 35 years of leadership experience, including more than a decade at the national level, spanning livestock, dairy development, and animal welfare. He has held some of India's most influential roles, notably as National Mission Director of the National Livestock Mission and Rashtriya Gokul Mission, where he led large‑scale programmes focused on livestock productivity, genetic improvement, feed and fodder systems, disease prevention, and farmer income enhancement. His work closely aligns with the company's focus on early mastitis detection, a critical yet often overlooked threat to dairy herd health and farm economics. Dr. Chaudhary brings a strong academic and technical foundation, holding an MTech from IIT Roorkee, an Executive MBA from IIM Lucknow, a PhD in Finance, and leadership training from the Harvard Kennedy School. This rare blend of scientific, managerial, and policy expertise enables him to guide agri‑tech innovation that is both data‑driven and grounded in real‑world dairy practices.
                                                    <br /><br />
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </section>
        </Layout>
    );
};

export default TeamsPage;
